import { render, staticRenderFns } from "./PromotionOfBilling.vue?vue&type=template&id=5dfa46ac&scoped=true"
import script from "./PromotionOfBilling.vue?vue&type=script&lang=ts"
export * from "./PromotionOfBilling.vue?vue&type=script&lang=ts"
import style0 from "./PromotionOfBilling.vue?vue&type=style&index=0&id=5dfa46ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa46ac",
  null
  
)

export default component.exports